<app-dialog-container>
  <div class="training-form-container">
    <!-- Header aprimorado -->
    <div class="form-header">
      <div class="header-content">
        <div class="title-section">
          <mat-icon class="header-icon">school</mat-icon>
          <h1 mat-dialog-title class="form-title">
            {{ typeCes === typeCesEnum.NEW ? 'Cadastrar Treinamento' :
            typeCes === typeCesEnum.EDIT ? 'Editar Treinamento' :
            'Visualizar Treinamento' }}
          </h1>
        </div>

        <div class="action-buttons">
          <button
            *ngIf="typeCes === typeCesEnum.EDIT"
            mat-icon-button
            (click)="changeType(typeCesEnum.SHOW)"
            class="view-btn"
            matTooltip="Visualizar">
            <mat-icon>visibility</mat-icon>
          </button>

          <button
            *ngIf="typeCes === typeCesEnum.SHOW"
            mat-icon-button
            (click)="changeType(typeCesEnum.EDIT)"
            class="edit-btn"
            matTooltip="Editar">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>

      <div class="progress-indicator">
        <mat-progress-bar
          mode="determinate"
          [value]="form.valid ? 100 : 50"
          class="form-progress">
        </mat-progress-bar>
      </div>
    </div>

    <!-- Form Content com rolagem -->
    <div class="form-content-scrollable">
      <div class="form-content">
        <form [formGroup]="form" class="training-form">

          <!-- Seção 1: Informações Básicas -->
          <div class="form-section">
            <div class="section-header">
              <mat-icon>info</mat-icon>
              <h2>Informações Básicas</h2>
            </div>

            <div class="form-row">
              <app-input
                [config]="getFieldConfig('trainingName')"
                [typeCes]="typeCes"
                [group]="form"
                class="full-width">
              </app-input>
            </div>

            <div class="form-row">
              <app-input
                [config]="getFieldConfig('partners')"
                [typeCes]="typeCes"
                [group]="form"
                (onSelect)="selectPartners($event)"
                class="half-width">
              </app-input>

              <app-input
                [config]="getFieldConfig('type')"
                [typeCes]="typeCes"
                [group]="form"
                class="half-width">
              </app-input>
            </div>
          </div>

          <!-- Seção 2: Configurações Técnicas -->
          <div class="form-section">
            <div class="section-header">
              <mat-icon>settings</mat-icon>
              <h2>Configurações Técnicas</h2>
            </div>

            <div class="form-row">
              <app-input
                [config]="getFieldConfig('system')"
                (onSelect)="selectSystem($event)"
                [typeCes]="typeCes"
                [group]="form"
                class="half-width">
              </app-input>

              <app-input
                [config]="getFieldConfig('systemVersion')"
                [typeCes]="typeCes"
                [group]="form"
                class="half-width">
              </app-input>
            </div>

            <div class="form-row">
              <app-input
                [config]="getFieldConfig('fileType')"
                [typeCes]="typeCes"
                [group]="form"
                class="full-width">
              </app-input>
            </div>
          </div>

          <!-- Seção 3: Arquivo e Descrição -->
          <div class="form-section">
            <div class="section-header">
              <mat-icon>cloud_upload</mat-icon>
              <h2>Arquivo do Treinamento *</h2>
            </div>

            <div class="upload-section">
              <app-input
                [config]="getFieldConfig('fileAttachment')"
                [typeCes]="typeCes"
                [group]="form"
                class="file-upload">
              </app-input>

              <div class="upload-info">
                <mat-icon>info</mat-icon>
                <p>Formatos aceitos: MP4, PDF, DOC, PPT, XLS</p>
                <p>Tamanho máximo: 500MB</p>
              </div>
            </div>

            <div class="form-row">
              <app-input
                [config]="getFieldConfig('fileDescription')"
                [typeCes]="typeCes"
                [group]="form"
                class="full-width description-field">
              </app-input>
            </div>
          </div>

          <!-- Preview Section (se houver dados) -->
          <div *ngIf="typeCes !== typeCesEnum.NEW && data" class="form-section">
            <div class="section-header">
              <mat-icon>preview</mat-icon>
              <h2>Preview do Treinamento</h2>
            </div>

            <div class="training-preview">
              <div class="preview-image">
                <img
                  [src]="data.image"
                  [alt]="data.trainingName"
                  class="course-preview-img">
              </div>

              <div class="preview-info">
                <h3>{{ data.trainingName }}</h3>
                <div class="preview-badges">
                  <span class="badge system-badge">{{ data.system }}</span>
                  <span class="badge type-badge">{{ data.type }}</span>
                </div>
                <p class="preview-description">{{ data.fileDescription }}</p>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>

    <!-- Form Actions (fixo na parte inferior) -->
    <div class="form-actions">
      <div class="action-section">
        <button
          *ngIf="typeCes !== typeCesEnum.SHOW"
          mat-raised-button
          color="primary"
          [disabled]="!form.valid || form.pristine"
          (click)="onSubmit(form.value)"
          class="save-btn">
          <mat-icon>save</mat-icon>
          {{ typeCes === typeCesEnum.NEW ? 'Criar Treinamento' :
          'Salvar Alterações' }}
        </button>
      </div>

      <!-- Form Status -->
      <div class="form-status" *ngIf="typeCes !== typeCesEnum.SHOW">
        <div class="status-item"
          [ngClass]="{ 'completed': form.get('trainingName')?.valid }">
          <mat-icon>{{ form.get('trainingName')?.valid ? 'check_circle' :
            'radio_button_unchecked' }}</mat-icon>
          <span>Título preenchido</span>
        </div>

        <div class="status-item"
          [ngClass]="{ 'completed': form.get('system')?.valid }">
          <mat-icon>{{ form.get('system')?.valid ? 'check_circle' :
            'radio_button_unchecked' }}</mat-icon>
          <span>Sistema selecionado</span>
        </div>

        <div class="status-item"
          [ngClass]="{ 'completed': form.get('fileAttachment')?.valid }">
          <mat-icon>{{ form.get('fileAttachment')?.valid ? 'check_circle' :
            'radio_button_unchecked' }}</mat-icon>
          <span>Arquivo anexado</span>
        </div>

        <div class="status-item"
          [ngClass]="{ 'completed': form.get('fileDescription')?.valid }">
          <mat-icon>{{ form.get('fileDescription')?.valid ? 'check_circle' :
            'radio_button_unchecked' }}</mat-icon>
          <span>Descrição preenchida</span>
        </div>
      </div>
    </div>
  </div>
</app-dialog-container>